enum ReactionListLocation {
    Dashboard = "dashboard",
    Screen = "screen",
    DotPopup = "dotPopup"
}

export default ReactionListLocation;
